<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5Zm-.75 13.447A5.991 5.991 0 0 1 3 9c0-.465.06-.908.158-1.343L6.75 11.25V12c0 .825.675 1.5 1.5 1.5v1.447Zm5.175-1.904A1.488 1.488 0 0 0 12 12h-.75V9.75A.752.752 0 0 0 10.5 9H6V7.5h1.5c.412 0 .75-.338.75-.75v-1.5h1.5c.825 0 1.5-.675 1.5-1.5v-.308A6.003 6.003 0 0 1 15 9c0 1.56-.6 2.977-1.575 4.043Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
